import * as React from "react"
const MissingNoteIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={15}
        fill="none"
        {...props}
    >
        <path
            fill="#EA3635"
            d="M1.071 2.143v10.714a1.07 1.07 0 0 0 1.072 1.071H8.57v-3.214c0-1.182.961-2.143 2.143-2.143h3.214V2.143a1.07 1.07 0 0 0-1.071-1.072H2.143A1.07 1.07 0 0 0 1.07 2.143ZM4.553 3.75a.802.802 0 0 1-.803.803.802.802 0 0 1-.804-.803c0-.445.359-.804.804-.804.445 0 .803.359.803.804Zm0 3.75a.802.802 0 0 1-.803.803.802.802 0 0 1-.804-.803c0-.445.359-.804.804-.804.445 0 .803.359.803.804Zm0 3.75a.802.802 0 0 1-.803.803.802.802 0 0 1-.804-.803c0-.445.359-.804.804-.804.445 0 .803.359.803.804Z"
            opacity={0.4}
        />
        <path
            fill="#EA3635"
            d="M2.143 13.929H8.57v-3.215c0-1.182.961-2.143 2.143-2.143h3.215V2.143a1.07 1.07 0 0 0-1.072-1.072H2.143A1.07 1.07 0 0 0 1.07 2.143v10.714a1.07 1.07 0 0 0 1.072 1.072Zm7.5-.446 3.84-3.84h-2.769a1.07 1.07 0 0 0-1.071 1.071v2.77ZM2.143 15A2.145 2.145 0 0 1 0 12.857V2.143C0 .96.96 0 2.143 0h10.714C14.04 0 15 .96 15 2.143v6.613c0 .569-.224 1.115-.626 1.516l-4.105 4.102A2.144 2.144 0 0 1 8.752 15h-6.61Zm.803-3.75c0-.445.359-.804.804-.804.445 0 .804.359.804.804a.802.802 0 0 1-.804.804.802.802 0 0 1-.804-.804Zm.804-6.696a.802.802 0 0 1-.804-.804c0-.445.359-.804.804-.804.445 0 .804.359.804.804a.802.802 0 0 1-.804.804ZM2.946 7.5c0-.445.359-.804.804-.804.445 0 .804.359.804.804a.802.802 0 0 1-.804.804.802.802 0 0 1-.804-.804Z"
        />
    </svg>
)
export default MissingNoteIcon
